// 统一往父窗口postMessage的入口，这边统一定义消息格式
/**消息类型 */
export enum MSG_TYPE {
  loginResult = "loginResult",
  bindTel = "bindTel",
  vipBuyClose = "vipBuyClose",
  vipBuyError = "vipBuyError",
  // 第三方登录
  thirdLoginOk = "thirdLoginOk",
  // 第三方登录失败
  thirdLoginFail = "thirdLoginFail",
  // 第三方注册
  thirdRegister = "thirdRegister",
  // 稿定页面融合
  gdMergeOk = "gdMergeOk",
}
/**错误消息格式 */
interface IErrData {
  /**自定义错误码 */
  err?: number;
  /**错误信息 */
  message: string;
}

type MsgDataModule = {
  [MSG_TYPE.loginResult]: {
    message: string;
  };
  [MSG_TYPE.bindTel]: {
    message: string;
  };
  [MSG_TYPE.vipBuyClose]: null;
  [MSG_TYPE.vipBuyError]: IErrData;

  [MSG_TYPE.thirdLoginOk]: {
    message?: string;
    /**是否是注册 */
    isRegister?: boolean;
  };
  [MSG_TYPE.thirdLoginFail]: IErrData;
  [MSG_TYPE.thirdRegister]: null;
  [MSG_TYPE.gdMergeOk]: null;
};

function getOpenerOrigin() {
  const opener = window.opener || window.parent;
  try {
    return opener.location.origin;
  } catch (error) {
    // 跨域下会无法读取，通过 document.referrer 读取来源页面
    return document.referrer;
  }
}

export function postMessageToParent<T extends MSG_TYPE>(
  type: T,
  data?: MsgDataModule[T] | IErrData
) {
  const opener: Window = window.opener || window.parent;

  if (opener) {
    opener.postMessage(
      {
        type,
        ...(data || null),
      },
      getOpenerOrigin() || "*"
    );
  }
}

/**
 * 监听页面postMessage事件
 * @param type
 * @param callback
 * @returns
 */
export function addMessageListener<T extends MSG_TYPE>(
  type: T,
  callback: (data: MsgDataModule[T]) => void
) {
  const cb = (event: MessageEvent) => {
    if (event.data?.type === type) {
      callback(event.data);
    }
  };

  window.addEventListener("message", cb);

  return () => {
    window.removeEventListener("message", cb);
  };
}
